import { render, staticRenderFns } from "./FooterBox.vue?vue&type=template&id=7e778aae&scoped=true&"
import script from "./FooterBox.vue?vue&type=script&lang=js&"
export * from "./FooterBox.vue?vue&type=script&lang=js&"
import style0 from "./FooterBox.vue?vue&type=style&index=0&id=7e778aae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e778aae",
  null
  
)

export default component.exports